export var ValidationRule;
(function (ValidationRule) {
    ValidationRule["Required"] = "isRequired";
    ValidationRule["Number"] = "isNumber";
    ValidationRule["MinValue"] = "minValue";
    ValidationRule["MaxValue"] = "maxValue";
})(ValidationRule || (ValidationRule = {}));
var Validate = /** @class */ (function () {
    function Validate(schema) {
        this.schema = schema;
    }
    Validate.prototype.check = function (values) {
        var errors = {};
        Object.entries(this.schema).forEach(function (_a) {
            var _b, _c;
            var accessor = _a[0], rules = _a[1];
            errors[accessor] = "";
            var value = values === null || values === void 0 ? void 0 : values[accessor];
            if (rules[ValidationRule.Required]) {
                if (!value || String(value).trim() === "") {
                    errors[accessor] = "Field is required";
                }
            }
            if (rules[ValidationRule.Number]) {
                if (errors[accessor]) {
                    return;
                }
                if (isNaN(Number(value))) {
                    errors[accessor] = "Field must be numeric";
                }
            }
            if (rules[ValidationRule.MinValue]) {
                var rule = rules[ValidationRule.MinValue];
                if (errors[accessor]) {
                    return;
                }
                if (values[accessor] < rule[0]) {
                    errors[accessor] = (_b = rule[1]) !== null && _b !== void 0 ? _b : "Field value cannot be less than " + rules.minValue[0];
                }
            }
            if (rules[ValidationRule.MaxValue]) {
                var rule = rules[ValidationRule.MaxValue];
                if (errors[accessor]) {
                    return;
                }
                if (values[accessor] < rule[0]) {
                    errors[accessor] = (_c = rule[1]) !== null && _c !== void 0 ? _c : "Field value cannot be more than " + rules.maxValue[0];
                }
            }
        });
        return errors;
    };
    return Validate;
}());
export { Validate };
